const initialState = {
    recentActivityCalendarData: [],
}

const recentActivityCalendarReducer = (state = initialState, action) => {
    if (action.type === 'RECENT_ACTIVITY_CALENDAR_QUERY') {
        let recentActivityCalendarData = action.data;
        return {...state, recentActivityCalendarData}
    }
    return state
}

export default recentActivityCalendarReducer